import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class OvertimesTable  {
    _originalTypeClassName = "zERP.BO.OvertimesTable";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
OvertimesTable.translate = translateService;
}
this.OvertimesLines = [];
this.OvertimeSums = [];
this.OvertimesTableKey = null;
this._key = this.OvertimesTableKey = 0; 
}

static translate: TranslateService;
_key: any;
OvertimesLines:any;
OvertimeSums:any;
private _OvertimesTableKey:any;
get OvertimesTableKey(): any {
    return this._OvertimesTableKey;
  }
set OvertimesTableKey(value: any) {
    this._OvertimesTableKey = value;
    this._key = value;
  }
static setOvertimesLines = ($this, items) => {
                if (items == null) items = [];
                if ($this.OvertimesLines == null) $this.OvertimesLines = [];

                const copyItems = Common.cloneObject(items);

                while ($this.OvertimesLines.length > 0) {
                    Domain.OvertimesTable.removeOvertimesLines($this, $this.OvertimesLines[0]);
                }

                Domain.OvertimesTable.addManyOvertimesLines($this, copyItems);
            }
static addManyOvertimesLines = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.OvertimesTable.addOvertimesLines($this, items[i]);
                }
            }
static addOvertimesLines = ($this, item) => {
                if ($this.OvertimesLines == null) $this.OvertimesLines = [];
                if (item == null || $this.OvertimesLines.indexOf(item) > -1) return;
                $this.OvertimesLines.push(item);
if (item.OvertimesTable != $this) {
Domain.OvertimesLine.setOvertimesTable(item, $this);
}
}
static addRangeOvertimesLines = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.OvertimesTable.addOvertimesLines($this, item));
            }
static removeOvertimesLines = ($this, item) => {
                if ($this == null || $this.OvertimesLines == null || $this.OvertimesLines.indexOf(item) === -1) return;
                var _index = $this.OvertimesLines.indexOf(item);
                $this.OvertimesLines.splice(_index, 1);
item.OvertimesTable = null;
}
static clearOvertimesLines = ($this) => { $this.OvertimesLines = null; }
static setOvertimeSums = ($this, items) => {
                if (items == null) items = [];
                if ($this.OvertimeSums == null) $this.OvertimeSums = [];

                const copyItems = Common.cloneObject(items);

                while ($this.OvertimeSums.length > 0) {
                    Domain.OvertimesTable.removeOvertimeSums($this, $this.OvertimeSums[0]);
                }

                Domain.OvertimesTable.addManyOvertimeSums($this, copyItems);
            }
static addManyOvertimeSums = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.OvertimesTable.addOvertimeSums($this, items[i]);
                }
            }
static addOvertimeSums = ($this, item) => {
                if ($this.OvertimeSums == null) $this.OvertimeSums = [];
                if (item == null || $this.OvertimeSums.indexOf(item) > -1) return;
                $this.OvertimeSums.push(item);
}
static addRangeOvertimeSums = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.OvertimesTable.addOvertimeSums($this, item));
            }
static removeOvertimeSums = ($this, item) => {
                if ($this == null || $this.OvertimeSums == null || $this.OvertimeSums.indexOf(item) === -1) return;
                var _index = $this.OvertimeSums.indexOf(item);
                $this.OvertimeSums.splice(_index, 1);
}
static clearOvertimeSums = ($this) => { $this.OvertimeSums = null; }


static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.OvertimesTableKey == null || $this.OvertimesTableKey == 0;
            }


}